import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

const slides = [
    {
        titleDark: "Advanced\nPhysiotherapy",
        titleOrange: "Rehabilitation\nEquipment",
        image: "https://primerehabindustries.in/Image/Home/1Hero.png",
        id: 2,
        slug: "chiropractic-drop-table"
    },
    {
        titleDark: "Innovative\nOccupational",
        titleOrange: "Therapy\nSolutions",
        image: "https://primerehabindustries.in/Image/Home/2Hero.png",
        id: 5,
        slug: "high-low-traction-table"
    },
    {
        titleDark: "Complete\nFunctional",
        titleOrange: "Recovery\nSystems",
        image: "https://primerehabindustries.in/Image/Home/3Hero.png",
        id: 7,
        slug: "high-low-two-fold-table"
    }
];

const Hero = () => {
    const navigate = useNavigate();
    const [currentSlide, setCurrentSlide] = useState(0);

    const nextSlide = useCallback(() => {
        setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, []);

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    };

    useEffect(() => {
        const timer = setInterval(() => {
            nextSlide();
        }, 5000);
        return () => clearInterval(timer);
    }, [nextSlide]);

    return (
        <section className="hero-section-new" id="home">
            <div className="hero-slider-new">

                <button className="slider-arrow left-arrow" onClick={prevSlide} aria-label="Previous slide">
                    <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
                </button>

                <div className="slide-content-wrapper">
                    {slides.map((slide, idx) => (
                        <div key={idx} className={`slide-item ${currentSlide === idx ? 'active' : ''}`}>
                            <div className="slide-text-col">
                                <div className="text-border-box">
                                    {/* Only the active slide's heading is rendered as an <h1>; all slides are
                                        present in the DOM for the crossfade, so the others use a <div> with the
                                        same classes to avoid multiple duplicate <h1> tags on the page. */}
                                    {currentSlide === idx ? (
                                        <h1 className="hero-heading-group">
                                            <span className="title-dark" style={{ display: 'block' }}>
                                                {slide.titleDark.split('\n').map((line, i) => (
                                                    <React.Fragment key={i}>
                                                        {line}<br />
                                                    </React.Fragment>
                                                ))}
                                            </span>
                                            <span className="title-orange" style={{ display: 'block' }}>
                                                {slide.titleOrange.split('\n').map((line, i) => (
                                                    <React.Fragment key={i}>
                                                        {line}<br />
                                                    </React.Fragment>
                                                ))}
                                            </span>
                                        </h1>
                                    ) : (
                                        <div className="hero-heading-group">
                                            <div className="title-dark">
                                                {slide.titleDark.split('\n').map((line, i) => (
                                                    <React.Fragment key={i}>
                                                        {line}<br />
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                            <div className="title-orange">
                                                {slide.titleOrange.split('\n').map((line, i) => (
                                                    <React.Fragment key={i}>
                                                        {line}<br />
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="slide-image-col">
                                <img 
                                    src={slide.image} 
                                    alt={`${slide.titleDark.replace('\n', ' ')} ${slide.titleOrange.replace('\n', ' ')} - Prime Rehab Industries`} 
                                    className="slide-image-item" 
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => navigate(`/product/${slide.slug || slide.id}`)}
                                />
                            </div>
                        </div>
                    ))}
                </div>

                <button className="slider-arrow right-arrow" onClick={nextSlide} aria-label="Next slide">
                    <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </button>

                <div className="slider-dots-container">
                    {slides.map((_, idx) => (
                        <span
                            key={idx}
                            className={`dot-indicator ${currentSlide === idx ? 'active' : ''}`}
                            onClick={() => setCurrentSlide(idx)}
                            aria-label={`Go to slide ${idx + 1}`}
                        />
                    ))}
                </div>

            </div>
        </section>
    );
};

export default Hero;
